import Lottie from 'lottie-react';
import styled from 'styled-components';

export const AnimationContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const LoadingLottie = styled(Lottie)`
  width: 30%;
`;
